import { SanitizeHTML } from '@/_helpers';
import styled from '@emotion/styled';
import EventLocationMap from './EventLocationMap';
import { BsArrowRepeat, BsChatDots, BsGeoAlt, BsPeople } from 'react-icons/bs';
import OurAccordion from '@/_elements/OurAccordion';
import { VscLoading } from 'react-icons/vsc';
import React, { useEffect, useMemo } from 'react';
import { css } from 'twin.macro';
import { Alert, Button, Form } from 'react-bootstrap';
import { ToolTip } from '@/_elements/ToolTip';
import AvatarUserPanel from '@/components/Features/Common/AvatarUserPanel';
import { CgDetailsMore } from 'react-icons/cg';
import { MdEventAvailable } from 'react-icons/md';
import dayjs from 'dayjs';
import CusotmRecurrence from '@/components/Features/Events/CustomRecurrence';
import { useState } from 'react';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';
const Content = styled.div`
    border-radius: 4px;
`;

export const ToggleContentContainer = ({ children, show = false, toggleText, IconComponent = null }) => {
    return (
        <div
            style={{
                borderRadius: '5px',
                border: '1px solid #f8f9fa',
            }}
        >
            <OurAccordion
                title={
                    <span
                        style={{
                            // backgroundColor: '#fbfbfb'
                            backgroundColor: 'white',
                        }}
                    >
                        {`${toggleText}`} {IconComponent ? <IconComponent className="mr-4" /> : null}
                    </span>
                }
                titleTag="span"
                defaultShow={show}
                titleStyle={{
                    // background: '#fbfbfb',
                    background: 'white',
                    paddingLeft: '2px',
                    fontWeight: '700',
                }}
                style={{ border: '1px solid #f8f9fa', borderRadius: '4px' }}
                contentStyle={{
                    backgroundColor: '#f8f9fa',
                    boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
                iconStyle={{ color: '#535353' }}
            >
                <Content>{children}</Content>
            </OurAccordion>
        </div>
    );
};
// export const DescriptionComponent = ({ data }) => {
//     if (!data) return null;

//     return (
//         <ToggleContentContainer toggleText="Description" IconComponent={CgDetailsMore}>
//             <SanitizeHTML html={data?.description || ''} />
//         </ToggleContentContainer>
//     );
// };

export const DescriptionComponent = ({ data, maxLength = 80 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!data || !data.description) return null;

    const description = data.description;
    const shouldTruncate = description.length > maxLength;
    const displayText = isExpanded
        ? description
        : (description || '').replace(/\n/g, ' ').slice(0, maxLength) + (shouldTruncate ? '...' : '');

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div>
            <div
                className="d-flex align-items-center text-muted"
                css={css`
                    font-size: 1.6rem;
                `}
            >
                <CgDetailsMore className="mr-2" />
                Description
                {shouldTruncate && (
                    <button
                        onClick={toggleExpand}
                        style={{
                            color: '#50aeb0',
                            fontWeight: '500',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            padding: '0 4px',
                            alignSelf: 'flex-start',
                            marginTop: '0',
                        }}
                    >
                        {isExpanded ? <>( Show Less )</> : <>( Show More )</>}
                    </button>
                )}
                {!isExpanded && (
                    <span
                        style={{
                            marginLeft: '8px',
                            flex: 1,
                            borderRadius: '4px',
                        }}
                    >
                        <SanitizeHTML html={displayText} style={{ margin: 0 }} />
                    </span>
                )}
            </div>

            {isExpanded && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '8px',
                        backgroundColor: '#f8f9fa',
                        padding: '10px',
                        borderRadius: '4px',
                        marginTop: '8px',
                    }}
                >
                    <SanitizeHTML html={displayText} style={{ flex: 1, margin: 0 }} />
                </div>
            )}
        </div>
    );
};
export const EventLocationComponent = ({ data }) => {
    if (!(data?.location || {})?.address) return null;
    return (
        <ToggleContentContainer toggleText="Event Location" IconComponent={BsGeoAlt}>
            <EventLocationMap defaultLocation={data.location} isDisabled={true} view={true} />{' '}
        </ToggleContentContainer>
    );
};

export const EventParticipantStatusComponent = ({
    currUser,
    data,
    loadingUsersData,
    selectedUsers,
    canSeeAllStatus,
    handleStatusChange,
    register,
    handleEventChannelClick,
    taskStatus,
}) => {
    return (
        <ToggleContentContainer toggleText="Participants Status" IconComponent={BsPeople}>
            <div className="">
                {loadingUsersData ? (
                    <VscLoading
                        className="spin"
                        css={css`
                            height: 24px;
                            width: 24px;
                        `}
                    />
                ) : (
                    <>
                        {selectedUsers?.length ? (
                            <>
                                <div className="d-flex flex-column justify-content-start align-items-start ">
                                    {selectedUsers
                                        ?.filter((user) => user._id === currUser._id || canSeeAllStatus)
                                        ?.map((user) => (
                                            <div
                                                key={user._id}
                                                className="w-100"
                                                css={css`
                                                    padding: 2px 0;
                                                    gap: 6px;
                                                    display: flex;
                                                    justify-content: space-between;
                                                    align-items: end;
                                                `}
                                            >
                                                <div
                                                    css={css`
                                                        display: flex;
                                                        flex-direction: row;
                                                        align-items: center;
                                                        gap: 1rem;
                                                    `}
                                                >
                                                    <AvatarUserPanel item={user} />
                                                    {user?.name}
                                                </div>
                                                <div
                                                    css={css`
                                                        display: flex;
                                                        gap: 4px;
                                                        width: 50%;
                                                        justify-content: space-between;
                                                    `}
                                                >
                                                    <Form.Control
                                                        css={css`
                                                            font-size: 1.5rem !important;
                                                            width: fit-content;
                                                        `}
                                                        ref={register}
                                                        onChange={(e) => handleStatusChange(user._id, e.target.value)}
                                                        as="select"
                                                        name="status"
                                                        disabled={!canSeeAllStatus && user._id !== currUser._id}
                                                        value={
                                                            taskStatus?.find((userId) => userId === user._id)
                                                                ? 'done'
                                                                : 'incomplete'
                                                        }
                                                    >
                                                        <option value="incomplete">Incompelete</option>
                                                        <option value="done">Complete</option>
                                                    </Form.Control>
                                                    <div
                                                        css={css`
                                                            display: flex;
                                                            flex-direction: column;
                                                            align-items: start;
                                                            gap: 0px;
                                                        `}
                                                    >
                                                        <ToolTip
                                                            text={`Chat with ${currUser?._id === user?._id ? data?.assignedBy?.name : user?.name}`}
                                                            cssStyles={
                                                                'top:-85% !important; left: -20% !important; min-width: 200px !important;width:fit-content !important;'
                                                            }
                                                        >
                                                            <Button
                                                                onClick={() => handleEventChannelClick(user?._id)}
                                                                css={css`
                                                                    width: 200px;
                                                                    text-align: left;
                                                                `}
                                                            >
                                                                <BsChatDots
                                                                    className="icon"
                                                                    css={css`
                                                                        margin-right: 8px;
                                                                        margin-bottom: 4px;
                                                                    `}
                                                                />
                                                                Chat with{' '}
                                                                {currUser?._id === user?._id ? 'Creator' : 'User'}
                                                            </Button>
                                                        </ToolTip>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </>
                        ) : null}
                    </>
                )}
            </div>
        </ToggleContentContainer>
    );
};

export const EventAttendanceComponent = ({
    data,
    isBusy,
    conflictEndTime,
    conflictEventTitle,
    userId,
    updateAttendance = () => {},
    disabled,
    loadingConflict,
    compactMode = false,
    checkConflicts = () => {},
}) => {
    const userAttendance = useMemo(() => {
        return (Array.isArray(data?.attendance) ? data?.attendance : [])?.find((item) => item.user === userId) || {};
    }, [data, userId]);

    const currentStatus = userAttendance?.status;

    // Use null initially to represent "no selection"
    const [currentValue, setCurrentValue] = useState(null);

    useEffect(() => {
        // Only set currentValue if we have a valid status
        if (currentStatus === 'accepted') {
            setCurrentValue(true);
        } else if (currentStatus === 'declined') {
            setCurrentValue(false);
        } else {
            setCurrentValue(null); // No selection when status is undefined or invalid
        }
    }, [currentStatus]);

    const attendanceOptions = [
        {
            value: true,
            label: 'Yes, I will attend',
            shortLabel: 'Yes',
            status: 'accepted',
            color: 'primary',
        },
        {
            value: false,
            label: 'No, I cannot attend',
            shortLabel: 'No',
            status: 'declined',
            color: 'danger',
        },
    ];

    const handleAttendanceChange = async (willAttend) => {
        const newStatus = willAttend ? 'accepted' : 'declined';
        await updateAttendance((data || {})._id, {
            status: newStatus,
        });
    };

    if (compactMode) {
        return (
            <ButtonGroup className="w-100 d-flex flex-row align-items-center">
                <div className="mr-2">Attending:</div>
                {attendanceOptions.map((option, idx) => {
                    const isSelected = currentValue === option.value;
                    return (
                        <ToggleButton
                            key={idx}
                            id={`attendance-radio-compact-${idx}`}
                            type="radio"
                            variant={isSelected ? option.color : `outline-${option.color}`}
                            name="attendance-radio-compact"
                            value={option.value}
                            checked={isSelected}
                            onChange={(e) => handleAttendanceChange(e.currentTarget.value === 'true')}
                            disabled={isBusy || disabled}
                            style={{ padding: '0.5rem 0.5rem', marginTop: '5px' }}
                        >
                            <span className="ml-2">{option.shortLabel}</span>
                        </ToggleButton>
                    );
                })}
            </ButtonGroup>
        );
    }

    return (
        <ToggleContentContainer toggleText="Attendance" IconComponent={MdEventAvailable} show={true}>
            <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Will you attend this event?</Form.Label>
                <div>
                    <ButtonGroup className="w-100">
                        {attendanceOptions.map((option, idx) => {
                            const isSelected = currentValue === option.value;
                            return (
                                <ToggleButton
                                    key={idx}
                                    id={`attendance-radio-${idx}`}
                                    type="radio"
                                    variant={isSelected ? option.color : `outline-${option.color}`}
                                    name="attendance-radio"
                                    value={option.value}
                                    checked={isSelected}
                                    onChange={(e) => handleAttendanceChange(e.currentTarget.value === 'true')}
                                    disabled={isBusy || disabled}
                                >
                                    <span className="ml-2">{option.label}</span>
                                </ToggleButton>
                            );
                        })}
                    </ButtonGroup>
                </div>
                <Button variant="outline-secondary" onClick={checkConflicts} disabled={isBusy || disabled}>
                    Check Conflicts
                </Button>
                {loadingConflict && (
                    <div className="mt-3">
                        <VscLoading className="spin" /> Checking conflicts...
                    </div>
                )}

                {conflictEndTime && (
                    <Alert variant="warning" className="mt-3 small">
                        <Alert.Heading className="h2">Schedule Conflict:</Alert.Heading>
                        <p className="mb-1">
                            You're busy until <strong>{dayjs(conflictEndTime).format('hh:mm A')}</strong>
                        </p>
                        <p className="mb-0">
                            Conflicting event: <strong>{conflictEventTitle}</strong>
                        </p>
                    </Alert>
                )}

                <Form.Text className="text-muted small mt-2 d-block">
                    Selecting "No" will hide this event from your Upcoming events list in map.
                </Form.Text>
            </Form.Group>
        </ToggleContentContainer>
    );
};
export const EventRecurringComponent = ({ data, recurringMessage, getRecurrenceData = () => {}, recurringUntil }) => {
    return (
        <ToggleContentContainer toggleText="Event Recurrence" IconComponent={BsArrowRepeat}>
            <CusotmRecurrence
                eventStartDate={new Date(data?.latestDatePointer || data?.date)}
                recurrenceData={getRecurrenceData(data?.recurring, new Date(data?.latestDatePointer || data?.date))}
                eventRecurringUntil={recurringUntil}
                recurringMessage={recurringMessage}
                showLabel={false}
            />
        </ToggleContentContainer>
    );
};
